import { useI18n } from '@change-corgi/core-react/i18n';

import type { ContractModalSource } from '#src/app/pages/ambassadors/landing/pageContext';
import { useAmbassadorsPageState } from '#src/app/pages/ambassadors/landing/pageContext';

type Result = ModelHookResult<
	{
		isOpen: boolean;
		source: ContractModalSource | null;
		ariaLabel: string;
		closeButtonAriaLabel: string;
	},
	{
		close: () => void;
	}
>;

export function useContractModal(): Result {
	const [{ contractModal }, actions] = useAmbassadorsPageState();
	const { translate } = useI18n();

	return {
		data: {
			isOpen: contractModal.open,
			source: contractModal.source,
			ariaLabel: translate('corgi.ambassadors.modal.title'),
			closeButtonAriaLabel: translate('corgi.ambassadors.modal.close_aria_label'),
		},
		actions: {
			close: actions.closeContractModal,
		},
	};
}
